/**
 * Canonical outbound URL for The Real Startup Book (2nd Edition).
 *
 * Centralized here so the footer link, post-game CTA, and any future
 * placements resolve the same destination. Mirrors the sibling
 * games-and-tools rollout in plinkromatic (see plinkromatic#440).
 */
export const RSB_URL = 'https://www.amazon.com/Real-Startup-Book-Product-Customers-ebook/dp/B0H18XH5JR/';
